import axios from "../axios";

/*  Get Project Name*/
export const getProjectName = (uid) => {
  return axios.get("/api/ExternalTicket/ProjectName", {
    params: { uid },
    headers: {
      "X-Public-Request": true,
    },
  });
};

/* Create External Ticket*/
export const CreateExternalTicket = (data) => {
  return axios.post(
    "/api/ExternalTicket/CreateExternalTicket",
    data,
    {
      headers: {
        "X-Public-Request": true,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const GetReviewPageData = (ticketUID, email) => {
  return axios.get(`/api/ExternalTicket/review/${ticketUID}?email=${email}`);
};

export const MarkReviewed = (payload) => {
  return axios.post("/api/ExternalTicket/reviewed", payload);
};

export const ReopenTicket = (payload) => {
  return axios.post("/api/ExternalTicket/reopen", payload);
};
